import React, { Component } from 'react';
import SVG from 'react-inlinesvg';
import { joinClasses } from 'components/utils/react_helper';

export default class FilterIcon extends Component {
  render() {
    const { option } = this.props;
    return (
      <div className="preferences-pane__icon">
        {this.renderIcon(option.icon, false)}
        {option.secondaryIcon && this.renderIcon(option.secondaryIcon, true)}
      </div>
    );
  }

  renderIcon(icon, isSecondary) {
    if (this.props.option.svg) {
      return <SVG className={this.iconClasses(isSecondary)} src={icon} />;
    } else {
      return <img className={this.iconClasses(isSecondary)} src={icon} />;
    }
  }

  iconClasses(isSecondary) {
    return joinClasses([
      'preferences-pane__icon-image',
      this.props.selected && 'preferences-pane__icon-image--selected',
      isSecondary && 'preferences-pane__icon-image--secondary',
    ]);
  }
}
